import { useCallback, useEffect, useState } from "react";
import MenuTop from "../../../../components/menu/top/menu-top";
import planData from "../../../../features/plans/forms/plans-data";
import './style.css';
import { fetchPlanService,  fetchPlanTypes, updatePlanService } from "../../../../features/plans/service/plan-service";
import { FormProps } from "../../../../shared/interfaces/form";
import Form from "../../../../components/form/form";
import { useAlert } from "../../../../components/alert/alert";
import { SEVERITY } from "../../../../shared/interfaces/alert";
import { useNavigate, useParams } from 'react-router-dom';
import Breadcrumb from "../../../../components/breadcrumb/breadcrumb";
import InfoComponent from "../../../../components/info/info";

export function EditPlan() {
    const { id } = useParams();
    const { showAlert } = useAlert();
    const navigate = useNavigate();
    const [formData, setFormData] = useState<FormProps[] | undefined>();
    const [intialPrice, setIntialPrice] = useState<number | undefined>();

    const handleEditPlan = async (formData: any) => {
        if(formData.price !== intialPrice) { formData.price = Math.round(Number(formData.price) * 100); }

        if(formData?.isUnlimited) { formData.quantityProjects = null; }
        
        if(id && formData) {
          const response = await updatePlanService(id, formData);

          if(response) {
            showAlert('Plano editado com sucesso', SEVERITY.SUCCESS);
            navigate('/planos');
          }
        }
    };

    const fetchPlanTypesData = useCallback(async () => {
        try {
            const planTypes = await fetchPlanTypes();
            const planTypesOptions = planTypes?.map(({ name, id}: any) => ({ label: name, value: id }));

            setFormData(planData(undefined, undefined, planTypesOptions));
        } catch (error) {
            console.log(error);
        }
    }, []);

    const fetchPlanData = useCallback(async (id: string) => { 
        try {
            const response = await fetchPlanService(id);
            const planTypes = await fetchPlanTypes();
            const planTypesOptions = planTypes?.map(({ name, id}: any) => ({ label: name, value: id }));

            const data = planData(id, response, planTypesOptions);
            setFormData(data);
            setIntialPrice(response.price);
        } catch (error) {
            console.log(error);
        }
    }, []); 

    useEffect(() => {
        if (id) fetchPlanData(id);
        fetchPlanTypesData();
    }, [fetchPlanData, fetchPlanTypesData, id]);

    return (
        <div className="container-client">
            <MenuTop />
            <div className='container-client__content'>
                <Breadcrumb links={['Planos', 'Editar plano']} href={['/planos', '']} onNavigate={navigate} />
                {formData && (
                    <>
                        <InfoComponent />
                        <Form
                            data={formData}
                            onSubmitForm={handleEditPlan}
                            title={`Editar plano`}
                            onCancel={() => navigate('/planos', {replace: true})}
                        />
                    </>
                )}
            </div>
        </div>
    );
}